export default __webpack_public_path__ + "static/media/img2.7544f880.jpg";